import { RouterModule, Routes } from '@angular/router';
import { ASSISTANT_URL_DOCUMENT_ID } from './@store/assistant';
import { ViassistAuthGuardService } from './shared/services/viassist-auth-guard.service';
import { authGuard } from './shared/services/auth-guard';
import { FlutterHeatingSystemsHelper } from './+flutter-heating-systems/flutter-heating-systems/flutter-heating-systems.helper';
import { flutterHeatingSystemsGuard } from './+flutter-heating-systems/flutter-heating-systems.guard';

export const routes: Routes = [
  {
    path: 'demo-settings',
    loadChildren: () =>
      import('./+demo-settings/demo-settings.module').then((m) => m.DemoSettingsModule),
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./+dashboard/dashboard.routing').then((m) => m.DASHBOARD_ROUTES),
  },
  {
    path: 'assistant',
    loadComponent: () =>
      import('./+assistant/assistant.component').then((m) => m.AssistantComponent),
    canActivate: [authGuard, ViassistAuthGuardService],
  },
  {
    path: 'assistant/:' + ASSISTANT_URL_DOCUMENT_ID,
    loadComponent: () =>
      import('./+assistant/assistant.component').then((m) => m.AssistantComponent),
  },
  {
    path: 'assistant/:' + ASSISTANT_URL_DOCUMENT_ID,
    loadComponent: () =>
      import('./+assistant/assistant.component').then((m) => m.AssistantComponent),
  },
  {
    path: FlutterHeatingSystemsHelper.RouteNames.Systems,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./+flutter-heating-systems/flutter-heating-systems/flutter-heating-systems').then(
            (m) => m.FlutterHeatingSystemsComponent
          ),
      },
      {
        path: ':id',
        loadComponent: () =>
          import('./+flutter-heating-systems/flutter-heating-systems/flutter-heating-systems').then(
            (m) => m.FlutterHeatingSystemsComponent
          ),
      },
    ],
    canActivate: [flutterHeatingSystemsGuard],
  },
  {
    path: FlutterHeatingSystemsHelper.RouteNames.UnregisteredSerials,
    loadComponent: () =>
      import('./+flutter-heating-systems/flutter-heating-systems/flutter-heating-systems').then(
        (m) => m.FlutterHeatingSystemsComponent
      ),
    canActivate: [flutterHeatingSystemsGuard],
  },
  {
    path: FlutterHeatingSystemsHelper.RouteNames.WarrantyCodes,
    loadComponent: () =>
      import('./+flutter-heating-systems/flutter-heating-systems/flutter-heating-systems').then(
        (m) => m.FlutterHeatingSystemsComponent
      ),
    canActivate: [flutterHeatingSystemsGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'not-found' },
];

export const AppRouting = RouterModule.forRoot(routes, { enableTracing: false });
